import { Component, Input, OnInit } from '@angular/core';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';

interface IConfirmationData {
  enabledCount: string;
  warningCount: string;
  unknownCount: string;
}

@Component({
  selector: 'app-confirmation-legend',
  templateUrl: './confirmation-legend.component.html',
  styleUrls: ['./confirmation-legend.component.css']
})
export class ConfirmationLegendComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  @Input() confirmationData: IConfirmationData;
  constructor(public commonUtil:CommonUtil, private rootScopeService: RootScopeService) {
    this.getRootScopeData();
  }

  ngOnInit(): void {
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }


}
